import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'
import { Segment, Statistic } from 'semantic-ui-react'
import DelivererOrderActions from '../../../reducers/delivererOrderReducer'
import utils from '../../../utils'

class DriverPerformanceList extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { drivers: {} }
  }
  componentDidMount() {
    const { orders, fetchDelivererOrder, delivererOrderLoaded, startFrom, endAt } = this.props

    const delivererKeys = _.uniq(_.map(orders, order => order.deliverer_key))

    if (!delivererOrderLoaded && orders && startFrom && endAt) {
      fetchDelivererOrder(delivererKeys, startFrom, endAt)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { orders, fetchDelivererOrder, startFrom, endAt } = this.props

    if (nextProps.orders !== orders && nextProps.orders) {
      const delivererKeys = _.chain(nextProps.orders)
        .map('deliverer_key')
        .uniq()
        .value()

      fetchDelivererOrder(delivererKeys, startFrom, endAt)
    }
  }

  renderRows = () => {
    const { activities, delivererOrders, delivererOrderLoaded } = this.props
    let driverOrderStats = [
      {
        key: 'avg-online-duration',
        label: 'Avg online duration',
        value: 0,
      },
      {
        key: 'avg-acceptance-rate',
        label: 'Avg Acceptance Rate',
        value: 0,
      },
      {
        key: 'avg-acceptance-distance',
        label: 'Avg Acceptance Distance',
        value: 0,
      },
      {
        key: 'avg-rejected-distance',
        label: 'Avg Rejected Distance',
        value: 0,
      },
      {
        key: 'avg-idle-time',
        label: 'Avg Idle Time',
        value: 0,
      },
    ]

    if (_.size(activities) > 0 && _.size(delivererOrders) > 0 && delivererOrderLoaded) {
      const { activities } = this.props

      const activityByDriver = _.groupBy(activities, 'deliverer_key')

      const rows = _.reduce(
        activityByDriver,
        (accumulator, groupedActivities, delivererKey) => {
          accumulator[delivererKey] = accumulator[delivererKey] ? accumulator[delivererKey] : {}
          accumulator[delivererKey]['onlinedDuration'] = this.onlineHour(groupedActivities)
          accumulator[delivererKey]['acceptanceRate'] = this.acceptanceRate(delivererOrders, delivererKey)
          accumulator[delivererKey]['avgRejectedDistance'] = this.avgRejectedDistance(
            delivererOrders,
            delivererKey
          )
          accumulator[delivererKey]['avgAcceptedDistance'] = this.avgAcceptedDistance(
            delivererOrders,
            delivererKey
          )
          accumulator[delivererKey]['avgIdleTime'] = this.avgIdleTime(delivererOrders, delivererKey)
          return accumulator
        },
        {}
      )

      driverOrderStats = [
        {
          key: 'avg-online-duration',
          label: 'Avg online duration',
          value: this.getAverage(rows, 'onlinedDuration'),
        },
        {
          key: 'avg-acceptance-rate',
          label: 'Avg Acceptance Rate',
          value: this.getAverage(rows, 'acceptanceRate'),
        },
        {
          key: 'avg-acceptance-distance',
          label: 'Avg Rejected Distance',
          value: this.getAverage(rows, 'avgRejectedDistance'),
        },
        {
          key: 'avg-rejected-distance',
          label: 'Avg Acceptance Distance',
          value: this.getAverage(rows, 'avgAcceptedDistance'),
        },
        {
          key: 'avg-idle-time',
          label: 'Avg Idle Time',
          value: this.getAverage(rows, 'avgIdleTime'),
        },
      ]
    }
    return (
      <React.Fragment>
        <Segment>
          <Statistic.Group items={driverOrderStats} widths="five" />
        </Segment>
      </React.Fragment>
    )
  }

  render() {
    return this.renderRows()
  }

  onlineHour = groupedActivities => {
    return _.sumBy(groupedActivities, ({ onlined_at, offlined_at }) => {
      if (!onlined_at || !offlined_at) return 0
      const onlinedAt = moment(onlined_at)
      const offlinedAt = moment(offlined_at)
      return moment.duration(offlinedAt.diff(onlinedAt)).asMinutes()
    })
  }

  acceptanceRate = (delivererOrders, delivererKey) => {
    const deliveredOrder = _.filter(
      delivererOrders[delivererKey],
      orderRequest => orderRequest.status === 'delivered'
    ).length

    const allOrderAltertToCustomer = delivererOrders[delivererKey]
      ? Object.values(delivererOrders[delivererKey]).length
      : 0

    return (deliveredOrder / allOrderAltertToCustomer) * 100
  }

  avgRejectedDistance = (delivererOrders, delivererKey) => {
    const allOrderAltertToCustomer = _.chain(delivererOrders[delivererKey])
      .filter(order => order.status === 'rejected')
      .meanBy(order => order.distance)
      .value()
    return allOrderAltertToCustomer
  }

  avgAcceptedDistance = (delivererOrders, delivererKey) => {
    const allOrderAltertToCustomer = _.chain(delivererOrders[delivererKey])
      .filter(order => order.status === 'delivered')
      .meanBy(order => order.distance)
      .value()
    return allOrderAltertToCustomer
  }

  avgIdleTime = (delivererOrders, delivererKey) => {
    const idleTime = []
    const orders = _.filter(delivererOrders[delivererKey], order => order.status === 'delivered')
    const groupedOrders = _.groupBy(orders, ({ created_at }) => moment(created_at).format('DDMMM'))

    _.each(groupedOrders, groupedOrders => {
      const orderLength = groupedOrders.length
      if (!orderLength >= 2) return 0

      for (let index = 0; index < orderLength; index++) {
        const currentOrder = groupedOrders[index]
        const nextOrder = groupedOrders[index + 1]

        if (!nextOrder) continue

        const finishingTime = moment(currentOrder.updated_at)
        const statingTime = moment(nextOrder.created_at)
        idleTime.push(moment.duration(statingTime.diff(finishingTime)).asMinutes())
      }
    })

    return _.mean(idleTime)
  }

  getAverage = (data, selectedFields) => {
    return utils.helpers.convertToFixedTwo(_.mean(_.map(data, selectedFields).filter(x => !Number.isNaN(x))))
  }
}

const mapState = ({ drivers, delivererOrders }) => ({
  delivererOrders: delivererOrders.data,
  delivererOrderLoaded: delivererOrders.loaded,
  activities: drivers.analyticDriverActivities,
})

const mapDispatch = {
  fetchDelivererOrder: DelivererOrderActions.getDelivererOrders,
}

export default connect(
  mapState,
  mapDispatch
)(DriverPerformanceList)



// WEBPACK FOOTER //
// ./src/components/drivers/views/driverPerformanceList.js